import CountryFlag from "../../transfer-windows/CountryFlag";

// Club logo chip for an entry (product rule 5). Prefers the stored logo
// snapshot; falls back to a monogram when a club has no crest (or is an
// unlisted name-only club). Renders nothing when there is no club.
//
// Accepts either the redesigned snapshot fields (club_name / club_logo /
// club_country) or the legacy free-text `club` string, so existing
// entries keep rendering.
function monogram(name) {
  return (name || "?").trim().charAt(0).toUpperCase() || "?";
}

const ClubChip = ({ entry, size = "sm" }) => {
  // Backend snapshot shape: club_snapshot:{name,logo} (null = "No club"),
  // plus flat club_name_snapshot / club_logo_snapshot, and the legacy
  // free-text `club` for entries that predate the picker. Country lives
  // on the entry-level `country` field (no club_country_snapshot).
  const snap = entry?.club_snapshot || null;
  const name = snap?.name || entry?.club_name_snapshot || entry?.club || "";
  if (!name) return null;
  const logo = snap?.logo || entry?.club_logo_snapshot || null;
  const country = entry?.country || "";
  const dim = size === "sm" ? 17 : 20;
  const text = size === "sm" ? "text-[12px]" : "text-[13px]";

  return (
    <span
      className={`inline-flex items-center gap-1.5 self-start bg-[#F8FAFC] border border-[#EAECF0] rounded-full pl-1 pr-2.5 py-0.5 font-medium text-[#344054] ${text}`}
    >
      {logo ? (
        <img
          src={logo}
          alt=""
          className="rounded-full object-contain flex-none bg-white"
          style={{ width: dim, height: dim, boxShadow: "inset 0 0 0 1px rgba(16,24,40,.1)" }}
          referrerPolicy="no-referrer"
        />
      ) : (
        <span
          className="inline-flex items-center justify-center rounded-full bg-[#EAF2FF] text-[#1866CC] font-bold flex-none"
          style={{ width: dim, height: dim, fontSize: dim * 0.45 }}
        >
          {monogram(name)}
        </span>
      )}
      <span className="truncate max-w-[160px]">{name}</span>
      {country && <CountryFlag country={country} width={14} height={10} />}
    </span>
  );
};

export default ClubChip;
